import styled from 'styled-components';

const TopDiv = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const ListStyle = {
    TopDiv,
};
